import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder, openAlert, useTranslate, encrypter, downloadFileNew, onImportExcelAsync } from '../lib'
import { SelectNesting } from './common/Inputs/Select'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { Alerts } from './common/Alerts'
import Loading from './Loading'
export default function NewUserStudio({ isModalOpen,  closeModal, campaign_id, sub_campaing_id, closeFunction, isCampaign = false, associateToProject = true, project_id = null }) {
  const [loadingUpload, setLoadingUpload] = useState(false)
  const [loading, setLoading] = useContext(loadingContext)
  const [alertModal, setAlertModal] = useState({ title: '', visible: false })
  const [error, setError] = useState({ name: "" })
  const [roleUser, setRoleUser] = useState(1)
  const [role, setRole] = useState(0)
  const { t } = useTranslate();
  const regionRef = useRef();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    (async () => {
      setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)
    })()

  }, []);

  function isNumeric(str) {
    return /^\d+$/.test(str);
  }
  
  // Validar que el string contenga al menos un punto
  function contienePunto(str) {
    return /\./.test(str);
  }  
 
  const onErrorStudio = errors => {
    if (errors.ccms_id_studio) {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: errors.ccms_id_studio.message, visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alert, visible: false }) });
    }
    
    if (errors.ccms_name_studio) {
      openAlert('#alert-ac-modal', () => { setAlertModal({ title: errors.ccms_name_studio.message, visible: true, error: true }) }, 4000,
          () => { setAlertModal({ ...alert, visible: false }) });
    }
  }

  const onSubmitNewStudio = data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const data2 = JSON.stringify({
      ccms_id: data.ccms_id_studio,
      ccms_name: data.ccms_name_studio,
      name: data.name,
      last_name: data.last_name,
      role: roleUser,
      project: project_id || null
    })
    const encry = encrypter(data2, 'IANestingKey')
    let url = `${urlValue}/studio/user/without/project`
    if (associateToProject) {
      url = `${urlValue}/studio/user`
    }
    setLoading(true)
    axios({
      method: 'post',
      url: url,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {"usuario": encry},
    })
      .then(function (response) {
        const newUser = response?.data?.user;
        if (isCampaign) {
          addUserCampaign(newUser.id)
        } else {
          openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
            () => { setAlertModal({ ...alert, visible: false }) });
          
          if (associateToProject){
            closeFunction()
          } else {
            closeFunction(newUser)
          }      
          closeModal()      
          setLoading(false)
        }
        
      })
      .catch(function (error) {
        console.log("error created user studio", error)
        setLoading(false)
      })
  }

  const addUserCampaign = user_id => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    axios({
      method: 'post',
      url: `${urlValue}/studio/campaign/adduserscampaign`,
      headers: {
        user: id,
        'access-token': token,
        'X-CSRF-Token': csrfToken
      },
      withCredentials: true,
      data: {
        campaing_id: campaign_id,
        sub_campaing_id: sub_campaing_id,
        user_id: user_id
      },
    })
      .then(function (response) {
        openAlert('#alert-ac-modal', () => { setAlertModal({ title: t('alerts.accountCreated'), visible: true }) }, 4000,
          () => { setAlertModal({ ...alert, visible: false }) });
        closeModal()
        setLoading(false)
      })
      .catch(function (error) {
        console.log("error created user studio", error)
        setLoading(false)
      })
  }

  const prepareExcelStudio = async (file) => {
    const DatosExcel = await onImportExcelAsync(file, ['BMS', 'NT_USER', 'Firstname', 'Lastname', 'Role']);
    uploadMaxiveStudio(DatosExcel);
  }

  const uploadMaxiveStudio = async (UsersExcel) => {
    
    if (!loadingUpload && UsersExcel.length > 0 && UsersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        setLoading(true)
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
        let message = ''
        const roles = [
          {'valor': 1, 'role': 'admin'}, 
          {'valor': 4, 'role': 'reader'}, 
          {'valor': 5, 'role': 'trainer'},
          // {'valor': 6, 'rol': 'superadmin'}          
        ]

        let url = `${urlValue}/studio/user/without/project`
        if (associateToProject) {
          url = `${urlValue}/studio/user`
        }

        for (var i = 0; i < UsersExcel.length; i++) {
          const BMS = UsersExcel[i].BMS.toString().trim()
          const NTUSER = UsersExcel[i].NT_USER.toString().trim()
          const roleuserform = UsersExcel[i]?.Role?.toString().trim()?.toLowerCase() || 'admin'
          let validate = true
          let rolevalue = 1

          if (role !== 6) {
            if (!contienePunto(NTUSER) || !isNumeric(BMS)){
              message = message + 'BMS: ' + BMS + ' -- NT USER: ' + NTUSER + '\n'
              validate = false
            }
          }

          const encontrado = roles.find(item => item.role === roleuserform);

          if (encontrado) {
            rolevalue = encontrado.valor;
          } else {
            message = message + 'BMS: ' + BMS + ' -- NT USER: ' + NTUSER + '\n'
            validate = false
          }

          if (validate) {
            const data = {
              ccms_id: BMS,
              ccms_name: NTUSER,
              name: UsersExcel[i].Firstname.toString().trim(),
              last_name: UsersExcel[i].Lastname.toString().trim(),
              role: rolevalue,
              project: project_id
            }
            
            const encry = encrypter(data, 'IANestingKey')
            
            try {
              const rest = await axios.post(url, {"usuario": encry}, {
                headers: {
                  user: id,
                  'access-token': token
                }
              });
              if (rest.status === 200 && !associateToProject) {
                closeFunction(rest?.data?.user)
              }

            } catch (error) {
              message = message + 'BMS: ' + BMS + ' -- NT USER: ' + NTUSER + '\n'
            }
          }

        }
        setLoading(false)
        if (message !== ''){
          message = t('alerts.checkExcelTemplate')
          openAlert('#alert-ac-modal', () => { setAlertModal({ title: message, visible: true, error: true }) }, 4000,
            () => { 
              setAlertModal({ ...alert, visible: false }) 
              closeModal()
              if (associateToProject) {
                window.location.reload();
              }
            });
        } 
        else {
          closeModal()
          if (associateToProject) {
            window.location.reload();
          }
        }

        
      }, 1000)

    } else {
      alert(t('alerts.intentExcelLimit'))

    }

  }

  return (
    <div id="container-modal" className="addUser-modal">
      <h2>{t('menu.addUserStudioForm')}</h2>
      <form onSubmit={handleSubmit(onSubmitNewStudio, onErrorStudio)}>
        <div className="inputs-modal">
          <div className="input">
            <span>{t('common.bms')}:</span>
            <input
              id="ccms_id_studio" placeholder={t('menu.specificUserId')}
              {...register('ccms_id_studio', { required: true, 
                ...(role !== 6 ? { pattern: {value: /^\d+$/, message: t('alerts.bmsNotNumeric')} } : {})
              })}
              type="text"
            />
          </div>
          <div className="input">
            <span>{t('common.ntUser')}:</span>
            <input id="ccms_name_studio" placeholder={t('menu.enterCCMS')} 
              {...register('ccms_name_studio', { required: true, 
                ...(role !== 6 ? { pattern: {value: /\./, message: t('alerts.ntUserFormat')} } : {})
              })} 
              type="text" 
            />
          </div>
          <div className="input">
            <span>{t('menu.firstName')}:</span>
            <input
              placeholder={t('menu.administratorFirstName')}
              {...register('name', { required: true })}
              type="text"
            />
          </div>
          <div className="input">
            <span>{t('menu.lastName')}:</span>
            <input 
              placeholder={t('menu.administratorLastName')}
              {...register('last_name', { required: true })} 
              type="text" 
            />
          </div>
          <SelectNesting
            id="role_user_studio"
            boxInfo={false} tooltipText= {t('menu.enterRole')} 
            title={t('menu.genai.selectRole')}
            onChange={(e) => {
              setRoleUser(e.target.value)
            }}
          >
            <option key='role0' value='1'>{t('common.admin')}</option>
            <option key='role1' value='4'>{t('common.reader')}</option>
            {(role == 6 || role == 5) && <option key='role2' value="5">{t('common.trainer')}</option>}                      
            {role == 6 && <option key='role3' value='6'>{t('common.superAdmin')}</option>}
            
          </SelectNesting>
        </div>

        <div className="flex items-center justify-end flex-wrap w-full" style={{marginTop: 30}}>
        <Tooltip anchorSelect="#uploadmax-studio" content={t('menu.uploadExcelUserTooltip')} place="top"
            style={{ whiteSpace: "pre-line", textAlign: "left" }}
            />
          <div id = 'uploadmax-studio' className="upload-excel btn-excel upload-btn trans">
            {loadingUpload ? <Loading /> : <>
              <img src="/icons/excel.svg" alt="newAns" style={{ width: 19, marginBottom: 0 }} />
              <label>{t('menu.uploadExcel')}</label>
            </>}
            <input type='file' accept='.xlsx, .xls' onChange={prepareExcelStudio} />
          </div>
          
          <div style={{ marginLeft: 10, marginTop: 20}}>
            <div style={{ cursor: 'pointer' }} onClick={() => { downloadFileNew("FormatUsersStudio.xlsx") }} className="a-download trans">
              <img src="/icons/download-icon.svg" alt="Img Template" style={{width: 15, marginRight: 5, marginBottom: 0}}/>
              {t('menu.downloadTemplate')}
            </div>
          </div>
        </div>
        
        <div className="buttons-modal">
          <button
            onClick={() => closeModal()}
            type="button"
            className="cancel btn-bottom btn-bottom-cancel"
          >
            {t('common.cancel')}
          </button>
          <button className="accept btn-bottom btn-bottom-create" type="submit" >
            {t('common.yes')}
          </button>
        </div>
      </form>
      {alertModal.visible && <Alerts id="alert-ac-modal" title={alertModal.title} error={alertModal.error} />}
    </div>
        )
}
